import Select2Component from 'components/select2Component';
import React, {forwardRef} from 'react';

export var DiasSemanaSelect2Component = forwardRef((props, _ref) => {
    const diasSemana = [
        { value: 'TodosDias', label: 'Todos os dias' },
        { value: 1, label: 'Domingo' },
        { value: 2, label: 'Segunda-feira' },
        { value: 3, label: 'Terça-feira' },
        { value: 4, label: 'Quarta-feira' },
        { value: 5, label: 'Quinta-feira' },
        { value: 6, label: 'Sexta-feira' },
        { value: 7, label: 'Sábado' }
    ];

    return (
        <Select2Component isMulti={true} ref={_ref} items={diasSemana}/>
    )
});
